import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import BaseTemplate from '../BaseTemplate';
import { Button, Label } from '../../atoms';
import {
  ReportingDetailsVerificationStatusForm,
  TranslationOrganism,
} from '../../organisms';
import cn from 'classnames';
import styles from './ReportingDetailsVerificationStatusesEditTemplate.module.css';
import { VerificationStatusResponseDto } from '../../../store/landscapeAPI/verificationStatus/dto/response/verification-status-response.dto';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import { PromiseSettledResult } from '../../../utils/types/types';

export interface ReportingDetailsVerificationStatusesEditTemplateProps {
  data: VerificationStatusResponseDto;
  handleEditVerificationStatus: (
    verificationStatus: VerificationStatusResponseDto
  ) => void;
  handleOnChange: (verificationStatus: VerificationStatusResponseDto) => void;
  handleImageOnChange: (imageMeta: ImageMeta) => void;
  setLanguage: React.Dispatch<React.SetStateAction<LocalesLanguagesConstants>>;
  selectedLanguage: LocalesLanguagesConstants;
  fromLanguage: LocalesLanguagesConstants;
  setFromLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  toLanguage: LocalesLanguagesConstants;
  setToLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  generateTranslation: () => Promise<void>;
  generateAllTranslations: () => Promise<PromiseSettledResult<void>[]>;
}

const ReportingDetailsVerificationStatusesEditTemplate: FC<
  ReportingDetailsVerificationStatusesEditTemplateProps
> = ({
  data,
  handleEditVerificationStatus,
  handleOnChange,
  handleImageOnChange,
  setLanguage,
  selectedLanguage,
  fromLanguage,
  setFromLanguage,
  toLanguage,
  setToLanguage,
  generateTranslation,
  generateAllTranslations,
}) => {
  const navigate = useNavigate();

  return (
    <BaseTemplate>
      <div className={styles.heading}>
        <Label content="Edit Verification Status" size="lg" />
        <Button
          variant="link"
          onClick={() => navigate('/reporting-details/verification-statuses')}
          className={cn(styles.buttonLink)}
        >
          Go back to verification status overview
        </Button>
      </div>
      <TranslationOrganism
        setLanguage={setLanguage}
        selectedLanguage={selectedLanguage}
        fromLanguage={fromLanguage}
        setFromLanguage={setFromLanguage}
        toLanguage={toLanguage}
        setToLanguage={setToLanguage}
        generateTranslation={generateTranslation}
        generateAllTranslations={generateAllTranslations}
      />
      <ReportingDetailsVerificationStatusForm
        data={data}
        handleVerificationStatus={handleEditVerificationStatus}
        handleOnChange={handleOnChange}
        handleImageOnChange={handleImageOnChange}
      />
    </BaseTemplate>
  );
};

export default ReportingDetailsVerificationStatusesEditTemplate;
